(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
          const checkbox = document.getElementById('p_checkbox');
            const submitButton = document.getElementById('submit_btn');
            console.log("privacy check wakeup"); // チェック状態が変更されたとき
            checkbox.addEventListener('change', () => {
              console.log(submitButton);
              console.log("privacy check click");
              if(checkbox.checked) {
                submitButton.disabled = false; // チェックが入っていればボタン有効化
              } else {
                submitButton.disabled = true; // チェックが外れていればボタン無効化
              }
            });
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const barElement = document.getElementById('custom-free-shipping-bar-{{ section.id }}');
    if (!barElement) return;

    const messageElement = barElement.querySelector('.custom-free-shipping-bar__message');
    const sectionSettings = {
      isEnabled: barElement.dataset.enabled === 'true',
      threshold: parseFloat(barElement.dataset.threshold),
      messageAlmost: barElement.dataset.messageTemplateAlmost,
      messageAchieved: barElement.dataset.messageAchieved,
      messageCartEmpty: barElement.dataset.messageCartEmpty
    };

    function formatAmountAsJapaneseYen(cents) {
      const amountInYen = cents / 100;
      const roundedAmount = Math.round(amountInYen);

      try {
        const numberFormatter = new Intl.NumberFormat('ja-JP', {
          style: 'decimal',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
        return numberFormatter.format(roundedAmount) + ' 円';
      } catch (e) {
        // Intl.NumberFormat がサポートされていないブラウザや予期せぬエラーの場合のフォールバック
        console.error("Intl.NumberFormat error:", e);
        // シンプルなカンマ区切りと円を追加 (限定的なフォールバック)
        let numStr = String(roundedAmount);
        let parts = numStr.split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return parts.join('.') + ' 円';
      }
    }

    function updateBar(cart) {
      if (!sectionSettings.isEnabled || sectionSettings.threshold <= 0 || !cart) {
        if (barElement) {
          barElement.classList.add('is-hidden');
          barElement.classList.remove('achieved', 'almost-there', 'cart-empty');
        }
        if (messageElement) messageElement.textContent = '';
        return;
      }

      const cartTotalPrice = cart.total_price;
      const itemCount = cart.item_count;
      let currentMessage = "";
      let showBar = false;

      if (barElement) {
        barElement.classList.remove('achieved', 'almost-there', 'cart-empty');
      }

      if (itemCount > 0) {
        if (cartTotalPrice >= sectionSettings.threshold) {
          currentMessage = sectionSettings.messageAchieved;
          if (barElement) barElement.classList.add('achieved');
          showBar = true;
        } else {
          const remainingAmountCents = sectionSettings.threshold - cartTotalPrice;
          const formattedRemainingAmount = formatAmountAsJapaneseYen(remainingAmountCents);
          currentMessage = sectionSettings.messageAlmost.replace('{amount}', formattedRemainingAmount);
          if (barElement) barElement.classList.add('almost-there');
          showBar = true;
        }
      } else if (sectionSettings.messageCartEmpty && sectionSettings.messageCartEmpty.trim() !== "") {
        currentMessage = sectionSettings.messageCartEmpty;
        if (barElement) barElement.classList.add('cart-empty');
        showBar = true;
      }

      if (messageElement) messageElement.textContent = currentMessage;

      if (barElement) {
        if (showBar && currentMessage.trim() !== "") {
          barElement.classList.remove('is-hidden');
        } else {
          barElement.classList.add('is-hidden');
           if (messageElement && currentMessage.trim() === "") {
              messageElement.textContent = '';
          }
        }
      }
    }

    function initializeBar() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
           updateBar(cart);
        })
        .catch(error => console.error('Error fetching initial cart for free shipping bar:', error));
    }

    document.addEventListener('cart:updated', function(event) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(fetchedCart => updateBar(fetchedCart))
        .catch(error => console.error('Error fetching cart after update for free shipping bar:', error));
    });

    window.refreshFreeShippingBar = function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => updateBar(cart))
        .catch(error => console.error('Error refreshing free shipping bar:', error));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeBar);
    } else {
      initializeBar();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-lp-collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sk-cgrid[data-layout="slider"]').forEach(function (root) {
      var track = root.querySelector('.sk-cgrid__items');
      var prevBtn = root.querySelector('[data-cgrid-prev]');
      var nextBtn = root.querySelector('[data-cgrid-next]');
      if (!track) return;

      function stepWidth() {
        var card = track.querySelector('.sk-cgrid__card');
        if (!card) return track.clientWidth * 0.9;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function scrollByDirection(direction) {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var next = track.scrollLeft + stepWidth() * direction;
        if (next < 0) {
          next = maxScroll;
        } else if (next > maxScroll - 1) {
          next = 0;
        }
        track.scrollTo({ left: next, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByDirection(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByDirection(1); });

      if (root.dataset.autoplay === 'true') {
        var speed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;
        var timer = null;

        function start() {
          if (timer) return;
          timer = setInterval(function () { scrollByDirection(1); }, speed);
        }

        function stop() {
          if (!timer) return;
          clearInterval(timer);
          timer = null;
        }

        start();
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
        root.addEventListener('focusin', stop);
        root.addEventListener('focusout', start);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-lp-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initStickyBar = (sectionRoot) => {
      if (!sectionRoot || sectionRoot.dataset.ctaStickyInitialized === 'true') {
        return;
      }

      const target = sectionRoot.querySelector('[data-cta-observe]');
      const bar = sectionRoot.parentElement
        ? sectionRoot.parentElement.querySelector('[data-cta-sticky]')
        : null;

      if (!target || !bar || typeof IntersectionObserver === 'undefined') {
        return;
      }

      sectionRoot.dataset.ctaStickyInitialized = 'true';

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        });
      }, { threshold: 0 });

      observer.observe(target);
    };

    const initAll = (container = document) => {
      const roots = container.querySelectorAll('.sk-cta[data-section-id]');
      roots.forEach((root) => initStickyBar(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-lp-flex-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initParallax = (sectionRoot) => {
      if (!sectionRoot || sectionRoot.dataset.parallaxInitialized === 'true') {
        return;
      }

      sectionRoot.dataset.parallaxInitialized = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const items = Array.from(sectionRoot.querySelectorAll('[data-parallax="true"]'));

      if (!items.length) {
        return;
      }

      let ticking = false;

      const update = () => {
        const viewportHeight = window.innerHeight;

        items.forEach((item) => {
          const rect = item.getBoundingClientRect();

          if (rect.bottom < 0 || rect.top > viewportHeight) {
            return;
          }

          const strength = parseFloat(item.style.getPropertyValue('--parallax-strength')) || 20;
          const centerOffset = (rect.top + rect.height / 2) - viewportHeight / 2;
          const translate = (centerOffset / viewportHeight) * strength * -1;
          const img = item.querySelector('.sk-flex__img');

          if (img) {
            img.style.transform = `translateY(${translate}px) scale(1.12)`;
          }
        });

        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    };

    const initAll = (container = document) => {
      const roots = container.querySelectorAll('.sk-flex[data-section-id]');
      roots.forEach((root) => initParallax(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-lp-fullscreen-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHero = (sectionRoot) => {
        if (!sectionRoot || sectionRoot.dataset.initialized === 'true') {
          return;
        }

        sectionRoot.dataset.initialized = 'true';

        const slides = Array.from(sectionRoot.querySelectorAll('.sk-full-hero__slide'));
        const prevButton = sectionRoot.querySelector('[data-slide-prev]');
        const nextButton = sectionRoot.querySelector('[data-slide-next]');
        const dots = Array.from(sectionRoot.querySelectorAll('[data-slide-dot]'));

        if (slides.length<= 1) {
        return;
      }

      let currentIndex = 0;
      let timer = null;
      const autoplayEnabled = sectionRoot.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = Number(sectionRoot.dataset.interval) || 5000;

      const render = (nextIndex) => {
          currentIndex = (nextIndex + slides.length) % slides.length;

          slides.forEach((slide, idx) => {
            const active = idx === currentIndex;
            slide.classList.toggle('is-active', active);
          });

          dots.forEach((dot, idx) => {
            const active = idx === currentIndex;
            dot.classList.toggle('is-active', active);
            dot.setAttribute(
              'aria-selected',
              active
                ? 'true'
                : 'false'
            );
          });
        };

        const stopAutoplay =() => {
          if (timer) {
            window.clearInterval(timer);
            timer = null;
          }
        };

        const startAutoplay =() => {
          if (!autoplayEnabled || timer) {
            return;
          }

          timer = window.setInterval(() => {
            render(currentIndex + 1);
          }, interval);
        };

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            render(currentIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            render(currentIndex + 1);
          });
        }

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const targetIndex = Number(dot.getAttribute('data-slide-dot'));
            render(targetIndex);
          });
        });

        sectionRoot.addEventListener('mouseenter', stopAutoplay);
        sectionRoot.addEventListener('mouseleave', startAutoplay);
        sectionRoot.addEventListener('focusin', stopAutoplay);
        sectionRoot.addEventListener('focusout', startAutoplay);

        startAutoplay();
      };

      const initAll = (container = document) => {
        const roots = container.querySelectorAll('.sk-full-hero[data-slider]');
        roots.forEach((root) => initHero(root));
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initAll());
      } else {
        initAll();
      }

      document.addEventListener('shopify:section:load', (event) => {
        initAll(event.target);
      });
    }
  )();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-lp-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.sk-pgrid[data-layout="slider"]').forEach(function (root) {
      var track = root.querySelector('.sk-pgrid__items');
      var prevBtn = root.querySelector('[data-pgrid-prev]');
      var nextBtn = root.querySelector('[data-pgrid-next]');
      if (!track) return;

      function scrollByDirection(direction) {
        track.scrollBy({ left: track.clientWidth * 0.9 * direction, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByDirection(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByDirection(1); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-lp-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGallery = (sectionRoot) => {
      if (!sectionRoot || sectionRoot.dataset.spotGalleryInitialized === 'true') {
        return;
      }

      sectionRoot.dataset.spotGalleryInitialized = 'true';

      const mainImg = sectionRoot.querySelector('[data-spot-main-img]');
      const mainSource = sectionRoot.querySelector('[data-spot-main-source]');
      const thumbs = Array.from(sectionRoot.querySelectorAll('[data-spot-gallery-thumb]'));

      if (! mainImg || thumbs.length === 0) {
        return;
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const fullSrc = thumb.getAttribute('data-full-src');
          const fullSrcset = thumb.getAttribute('data-full-srcset');
          const fullAlt = thumb.getAttribute('data-full-alt');

          if (fullSrc) {
            mainImg.src = fullSrc;
          }

          if (fullSrcset) {
            mainImg.srcset = fullSrcset;
          }

          if (fullAlt) {
            mainImg.alt = fullAlt;
          }

          if (mainSource && fullSrc) {
            mainSource.srcset = fullSrc;
          }

          thumbs.forEach((otherThumb) => {
            otherThumb.classList.toggle('is-active', otherThumb === thumb);
          });
        });
      });
    };

    const initAll = (container = document) => {
      const roots = container.querySelectorAll('.sk-spot[data-section-id]');
      roots.forEach((root) => initGallery(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
